




































import Vue from 'vue';
import Tooltip from '../components/Tooltip.vue';

export default Vue.extend({
  props: {
    numGenerated: {
      type: Number,
      required: true,
    },
    credits: {
      type: Number,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title(): string {
      return `${this.remaining} report credit${this.pluralize} remaining.`;
    },
    remaining(): number {
      return this.credits - this.numGenerated;
    },
    pluralize(): string {
      return (this.remaining > 1) ? 's' : '';
    },
    outOfCredits(): boolean {
      return (this.remaining === 0);
    },
  },
  components: {
    Tooltip,
  },
});
